
import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress
} from '@mui/material';

// components
import Iconify from '../../iconify';
import CustomModal from '../../modal/CustomModal';

// hooks
import { useAxios } from '../../../context/AxiosHookContext';

// sections
import { UserListHead, UserListToolbar } from '../../../sections/@dashboard/user';

// form
import CommunicationsReceivedModalForm from "../../forms/communications/communicationsModalForm/CommunicationsReceivedModalForm"
import { formatoFechaAmFm } from '../../../context/DateInstance';
import { useAuth } from '../../../context/AuthContext';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'No. Solicitud', alignRight: false },
  { id: 'name', label: 'No. Documento', alignRight: false },
  { id: 'name', label: 'Adjuntos', alignRight: false },
  { id: 'name', label: 'Asunto', alignRight: false },
  { id: 'name', label: 'Agente / Contacto', alignRight: false },
  { id: 'name', label: 'Fecha recepción', alignRight: false },
  { id: 'name', label: 'Tipo documento', alignRight: false },
  { id: 'name', label: 'Via de recepción', alignRight: false },
  { id: 'name', label: 'Dirigido a', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function CommunicationPage() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [openModaOrganizations, setOpenModalOrganizations] = useState(false);
  const { currentUser } = useAuth();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [communicationList, setCommunicationList] = useState([])
  const [valuesToEdit, setValuesToEdit] = useState({})
  const [loadingExcelReport, setLoadingExcelReport] = useState(false);


  const COMMUNICATIONS_API = `/communications/getAllReceived?page=${page}&limit=10&noDocumento=${filterName}`
  const axios = useAxios();

  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const getCommunications = useCallback(async () => {
    try {
      setCommunicationList([])
      setLoading(true);
      const { data } = await axios.get(COMMUNICATIONS_API);
      setCommunicationList(data.data.list);
      setTotalPages(data.data.total_pages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, COMMUNICATIONS_API, setCommunicationList, setLoading]);


  const newCommunication = () => {
    setValuesToEdit({});
    setOpenModalOrganizations(true);
  }

  const getExcelReport = useCallback(async () => {
    try {

      setLoadingExcelReport(true);
      const response = await axios.get("/communications/received/export_excel", {
        responseType: 'blob' // Indica que esperas una respuesta de tipo Blob
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const a = document.createElement('a');
      a.href = url;
      a.download = `${new Date().toISOString()}.xlsx`; // Nombre del archivo para descargar
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExcelReport(false)
    }
  }, [axios]);

  useEffect(() => {
    getCommunications();
  }, [getCommunications, filterName])


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Numera | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>

      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          Recibidas
        </Typography>

        <Stack direction="row" alignItems="center" spacing={2} mb={5}>

          <Button onClick={getExcelReport} variant="contained" startIcon={loadingExcelReport ? <CircularProgress size={'15px'} sx={{ color: 'white', marginRight: '6px' }} /> : <Iconify icon="file-icons:microsoft-excel" />}>
            {loadingExcelReport ? "Exportando reporte" : "Exportar reporte"}
          </Button>

          {
            (currentUser.role.includes("Registra comunicaciones externas")) &&
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={newCommunication}>
              Registrar
            </Button>
          }
        </Stack>

      </Stack>

      <Card>

        <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <UserListHead
              headLabel={TABLE_HEAD}
            />
            <TableBody>
              {communicationList?.map((row) =>

              (
                <TableRow hover key={row._id} tabIndex={-1} role="checkbox"
                  onDoubleClick={()=>{
                    setValuesToEdit(row);
                    setOpenModalOrganizations(true);
                  }}
                >

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.noRequest || ""}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.noDocumento || ""}
                    </Typography>
                  </TableCell>
                  
                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                    {row?.files?.length ? "Si" : "No"}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.asunto || ""}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.personaContacto}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.fechaRecepcionDocumento ? formatoFechaAmFm(row?.fechaRecepcionDocumento) : ""}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.tipoDocumento || ""}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.viaRecepcion?.description || ""}
                    </Typography>
                  </TableCell>

                  <TableCell component="th" scope="row" padding="normal">
                    <Typography variant="subtitle2" noWrap>
                      {row?.dirigidoA || ""}
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <IconButton size="large" color="inherit" onClick={(e) => { handleOpenMenu(e, row) }}>
                      <Iconify icon={'eva:more-vertical-fill'} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

            </TableBody>

            {
              loading === true &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

            {
              (communicationList.length === 0 && loading === false) &&
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >

                      <Typography variant="h6" paragraph>
                        Sin resultados
                      </Typography>

                      <Typography variant="body2">
                        No se encontraron resultados
                        <br /> Intente con otra búsqueda.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            }

          </Table>
        </TableContainer>

        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChangePage}

          sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
        />


      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {
           (currentUser.role.includes("Registra comunicaciones externas")) &&
          <MenuItem onClick={() => { setOpenModalOrganizations(true); setOpen(null) }} >
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Editar
          </MenuItem>
        }

      </Popover>

      <CustomModal
        open={openModaOrganizations}
        modalStyle={{ maxWidth: 800, minWidth: 320 }}
        title={"Formulario de comunicaciones recibidas"}
      >
        <CommunicationsReceivedModalForm communication={valuesToEdit} onClose={() => { setOpenModalOrganizations(false); getCommunications() }} />
      </CustomModal>
    </>
  );
}